<template>
    <section>
        <v-card flat>
            <div class="file-upload-container">
                <div
                    class="drop-area"
                    :class="{ 'drag-over': isDragOver }"
                    @dragover.prevent="handleDragOver"
                    @dragleave="handleDragLeave"
                    @drop.prevent="handleFileDrop"
                >
                    <p v-if="!form[model]">
                        Drag and drop an image here<br />
                        <br />or<br />
                        <br /><v-btn color="primary" @click="browseFile" block class="custom-hover-primary bg-yellow text-white"
                            >Browse</v-btn
                        >
                        <br />or<br />
                        <br /><v-btn @click="dialogCapture = true" block class="custom-hover-primary bg-yellow text-white">Capture</v-btn>
                    </p>
                    <div v-else class="position-relative">
                        <v-img height="100" :src="form[model]" alt="Selected Image" @click="clearFile"></v-img>
                        <v-icon color="error" icon="mdi-delete" class="mt-5" @click="clearFile"></v-icon>
                        <!-- <v-btn color="error" icon="mdi-delete" class="mt-5" @click="removeBackground(form[model])">R BG</v-btn> -->
                    </div>
                    <input type="file" ref="fileInput" accept="image/*" @change="handleFileSelect" style="display: none" />
                </div>
            </div>
        </v-card>

        <section>
            <v-dialog max-width="400" v-model="dialogCapture">
                <v-card :title="`Take a picture`">
                    <v-card-text class="text-center" color="primary">
                        <div class="position-relative" v-if="!form[model]">
                            <WebCamUI
                                class="webcam"
                                ref="webcam"
                                :fullscreenButton="{ type: Object, default: { display: false } }"
                                :takePhotoButton="{ type: Object, default: { display: false } }"
                                @photoTaken="photoTakenEvent"
                            />
                            <v-btn color="primary" icon="mdi-camera" @click="takePhoto"></v-btn>
                        </div>
                        <div class="position-relative text-center" v-else>
                            <v-img :src="form[model]" class="position-relative image-capture" style="opacity: 0.5"></v-img>
                            <div class="loader position-absolute" style="top: 50%; left: 50%; transform: translate(-50%, -50%)"></div>
                            <div class="searching-loader mx-auto mt-5"></div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </section>
    </section>
</template>
<script>
export default {
    props: ['form', 'model'],
    data() {
        return {
            dialogCapture: false,
            isDragOver: false,
            api: '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'
        };
    },

    methods: {
        async removeBackground(base64Image) {
            const apiKey = this.api; // Replace with your Hugging Face API key

            const response = await fetch('https://api-inference.huggingface.co/models/segmind/RemoveBG', {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${apiKey}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ inputs: base64Image })
            });

            if (!response.ok) {
                console.error('Error:', await response.text());
                return null;
            }

            const blob = await response.blob();
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.readAsDataURL(blob);
            });
        },
        async takePhoto() {
            try {
                const photo = await this.$refs.webcam.takePhoto();
            } catch (err) {
                console.log(err);
            }
        },
        async photoTakenEvent({ blob, image_data_url }) {
            if (!image_data_url) return null;
            this.dialogCapture = false;
            this.form[this.model] = image_data_url;
        },
        // Handle drag over event to show visual feedback
        handleDragOver(event) {
            this.isDragOver = true;
        },

        // Handle drag leave event to reset visual feedback
        handleDragLeave() {
            this.isDragOver = false;
        },

        // Handle file drop event
        handleFileDrop(event) {
            const files = event.dataTransfer.files;
            if (files.length > 0) {
                this.convertToBase64(files[0]);
            }
            this.isDragOver = false;
        },

        // Handle file selection from browse
        browseFile() {
            this.$refs.fileInput.click();
        },

        // Handle file selection change
        handleFileSelect(event) {
            const file = event.target.files[0];
            if (file) {
                this.convertToBase64(file);
            }
        },

        // Convert image file to base64
        convertToBase64(file) {
            if (!file.type.startsWith('image/')) {
                alert('Please upload an image file!');
                return;
            }

            const reader = new FileReader();
            reader.onloadend = () => {
                this.form[this.model] = reader.result; // This will store the base64 string in `image`
            };
            reader.readAsDataURL(file); // Read the file as base64
        },

        // Clear the file input and reset state
        clearFile() {
            this.form[this.model] = null;
            this.$refs.fileInput.value = ''; // Clear the file input field
        }
    }
};
</script>
<style scoped>
.file-upload-container {
    /* width: 300px; */
    text-align: center;
}

.drop-area {
    border: 2px dashed #ddd;
    padding: 20px;
    cursor: pointer;
    font-size: 16px;
}

.drop-area.drag-over {
    border-color: #007bff;
    background-color: #e9f7fd;
}

.drop-area p {
    margin: 0;
    font-size: 14px;
    color: #333;
}

.drop-area span {
    color: #007bff;
    text-decoration: underline;
}

input[type='file'] {
    display: none;
}
</style>
